module.exports = __webpack_public_path__ + "static/rattleorganic1-3d505b69fd23ea818c0a5342c95b38ae.jpeg";